import request from '@/utils/request'

// 고객 회원승인관리 조회
export function getClientMemberApproval(params, isNotify) {
  return request({
    url: `/api/getClientMemberApproval`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    data: params,
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 고객 회원승인 완료
export function clientMemberApproval(params) {
  return request({
    url: `/api/clientMemberApproval`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    data: params,
    Notify: { apitype: 'saved' }
  })
}
// 고객 회원승인 거절
export function clientMemberRefuse(params) {
  return request({
    url: `/api/clientMemberRefuse`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    data: params,
    Notify: { apitype: 'saved' }
  })
}
// 고객 회원승인관리 삭제
export function deleteClientMemberApproval(params, isNotify) {
  return request({
    url: `/api/deleteClientMemberApproval`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    data: params,
    Notify: { use: isNotify, apitype: 'deleted' }
  })
}